const en = {
  identifyAs: 'You identify as....',
  fancyBadges: 'We design some fancy badges for you',
  selectGender: 'Select gender',
  male: 'Male',
  female: 'Female',
  gmail: 'Gmail',
  save: 'Save',
};

export default en;
